import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { Card } from '@avanta/shared/components/ui/Card';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { PasswordChange } from 'pages/Auth/RecoverPassword/components';
import { useUserStore } from 'stores/user';
import { useSetupPassword } from './useSetupPassword';

export const ProfileSetup = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.AUTH);
  const user = useUserStore(state => state.user);
  const { mutateAsync: setPassword, isPending: isSettingPassword } = useSetupPassword();

  if (!user) {
    return <LoadingScreen />;
  }

  if (!user.requiredProfileSetup) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  const handlePasswordSubmit = async (password: string): Promise<void> => {
    await setPassword({ password });
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gray-50 p-24">
      <Card className="w-full max-w-96 rounded-2xl bg-white p-10 shadow-md">
        <div className="flex flex-col items-center justify-center gap-6">
          <h2 className="text-2xl font-bold text-center">
            {t('ProfileSetup.PasswordChange.heading')}
          </h2>
          <PasswordChange
            onSubmit={handlePasswordSubmit}
            isLoading={isSettingPassword}
            showBackLink={false}
          />
        </div>
      </Card>
    </div>
  );
};
